import React from 'react';
import PropTypes from 'prop-types';
import SmartAlertTrendDescription from 'components/triggers/SmartAlertTrendDescription';
import TriggerRuleInfo from 'records/TriggerRuleInfo';
import EditIcon from 'components/pure/utils/icon/EditIcon';
import './SmartAlertTrendDisplay.styl';
import CreateTrendAction from 'components/triggers/trigger-actions/CreateTrendAction';
import {List} from 'immutable';
import TriggerTrend from 'records/TriggerTrend';

export default class SmartAlertTrendDisplay extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {editMode: !!props.startInEditMode};
  }

  render() {
    const {rule, antiRules, trend} = this.props;
    const {editMode} = this.state;

    if (!editMode && trend) {
      return (
        <div className="smart-alert-trend-display">
          <SmartAlertTrendDescription trend={trend} />
          <EditIcon className="pointer" onClick={() => this.setState({editMode: true})} />
        </div>
      );
    }

    return (
      <div className="smart-alert-trend-display">
        <CreateTrendAction ruleId={rule.id} trend={trend} rule={rule} antiRules={antiRules} />
      </div>
    );
  }
}

SmartAlertTrendDisplay.propTypes = {
  rule: PropTypes.instanceOf(TriggerRuleInfo),
  trend: PropTypes.instanceOf(TriggerTrend),
  antiRules: PropTypes.instanceOf(List), // List<AntiRule>
};
